import { Link } from "react-router-dom";
import { buttonClass } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

export function NotFoundPage() {
  return (
    <EmptyState
      title="Page not found"
      description="The page you opened does not exist."
      action={
        <Link to="/" className={buttonClass("outline", "sm")}>
          Go to the dashboard
        </Link>
      }
    />
  );
}
